class AuthoriseController {
  /* @ngInject */
  constructor($window, $location, $http, Session, urls) {
    this.$window = $window;
    this.$location = $location;
    this.$http = $http;
    this.Session = Session;
    this.urls = urls;
  }

  $onInit() {
    const params = this.$location.search();
    const { location } = this.$window;

    const url = `${this
      .urls.LOGIN_APP}/api/authorise`;
    let continueUrl = '';
    return this
      .$http
      .post(url, Object.assign(params, { allow: 'true' }), { params })
      .then(({ data }) => {
        if (params.membership_type) {
          location.href = `${data}&membershipType=${params.membership_type}&membershipAmount=${params.membership_amount}`;
        } else {
          if (params.continue) {
            continueUrl = `&state=${params.continue}`;
          }
          location.href = `${data}${continueUrl}`;
        }
      })
      .catch((err) => {
        const { data } = err;
        return (this.error = (data && data.error));
      });
  }
}

export default AuthoriseController;



// WEBPACK FOOTER //
// ./client/app/authorise/authorise.controller.js